export default __webpack_public_path__ + "static/media/Sixth.82da035f.png";